import { sortBy } from 'lodash';

import { Group } from './components/FunctionalGroup';

export const functionalGroups: Group[] = [
  {
    name: 'Carbonyl compounds',
    smarts: [],
    subgroups: [
      {
        name: 'Ketone',
        smarts: ['[#6][#6X3](=O)[#6]'],
        subgroups: [],
      },
      {
        name: 'Aldehyde',
        smarts: ['[CX3H1](=O)[#6]'],
        subgroups: [],
      },
      {
        name: 'Carboxylic acid',
        smarts: ['[CX3](=O)[OX2H1]'],
        subgroups: [],
      },
      {
        name: 'Ester',
        smarts: ['[#6][CX3](=O)[OX2H0][#6]'],
        subgroups: [],
      },
      {
        name: 'Amide',
        smarts: ['[NX3][CX3](=[OX1])[#6]'],
        subgroups: [
          {
            name: 'Primary',
            displayName: 'Primary amide',
            smarts: ['[NX3H2][CX3](=[OX1])[#6]'],
            subgroups: [],
          },
          {
            name: 'Secondary',
            displayName: 'Secondary amide',
            smarts: ['[#6][NX3H1][CX3](=[OX1])[#6]'],
            subgroups: [],
          },
          {
            name: 'Tertiary',
            displayName: 'Tertiary amide',
            smarts: ['[#6][NX3]([#6])[CX3](=[OX1])[#6]'],
            subgroups: [],
          },
          {
            name: 'Weinreb',
            displayName: 'Weinreb amide',
            smarts: ['[CH3][O][NX3]([CH3])[CX3](=[OX1])[#6]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Acyl halide',
        smarts: ['[CX3](=[OX1])[F,Cl,Br,I]'],
        subgroups: [],
      },
      {
        name: 'Urea',
        smarts: ['[NX3][CX3](=[OX1])[NX3]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Hydroxy groups',
    smarts: [],
    subgroups: [
      {
        name: 'Alcohol',
        smarts: ['[#6][OX2H;!$(OC(=O))]'],
        subgroups: [
          {
            name: 'Primary',
            displayName: 'Primary alcohol',
            smarts: ['[CX4;H2][OX2H]'],
            subgroups: [],
          },
          {
            name: 'Secondary',
            displayName: 'Secondary alcohol',
            smarts: ['[#6][CX4;H1;!$(C(O)O)]([#6])[OX2H]'],
            subgroups: [],
          },
          {
            name: 'Tertiary',
            displayName: 'Tertiary alcohol',
            smarts: ['[CX4;H0!$(C(O)O)]([#6])([#6])[OX2H]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Phenol',
        smarts: ['[c][OX2H;!$(OC(=O))]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Nitrogen',
    smarts: [],
    subgroups: [
      {
        name: 'Amine',
        smarts: [],
        image: 'nitrogen-amine',
        subgroups: [
          {
            name: 'Primary',
            displayName: 'Primary amine',
            smarts: [],
            subgroups: [
              {
                name: 'Aliphatic',
                displayName: 'Aliphatic primary amine',
                smarts: ['[C][NX3;H2;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
              {
                name: 'Aromatic',
                displayName: 'Aromatic primary amine',
                smarts: ['[c][NX3;H2;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
            ],
          },
          {
            name: 'Secondary',
            displayName: 'Secondary amine',
            smarts: [],
            subgroups: [
              {
                name: 'Aliphatic',
                displayName: 'Aliphatic secondary amine',
                smarts: ['[C][NX3;H1;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
              {
                name: 'Aromatic',
                displayName: 'Aromatic secondary amine',
                smarts: ['[c][NX3;H1;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
            ],
          },
          {
            name: 'Tertiary',
            displayName: 'Tertiary amine',
            smarts: [],
            subgroups: [
              {
                name: 'Aliphatic',
                displayName: 'Aliphatic tertiary amine',
                smarts: ['[C][NX3;H0;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
              {
                name: 'Aromatic',
                displayName: 'Aromatic tertiary amine',
                smarts: ['[c][NX3;H0;!$(NC=O);!$(NC=S);!$(NC=N);!$([N+](=O)[O-])]'],
                subgroups: [],
              },
            ],
          },
        ],
      },
      {
        name: 'Nitrile',
        smarts: ['[#6]C#N'],
        subgroups: [],
      },
      {
        name: 'NH (heterocylic)',
        smarts: ['[n;H1]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Halogen',
    smarts: [],
    subgroups: [
      {
        name: 'Aliphatic',
        smarts: [],
        subgroups: [
          {
            name: 'F',
            smarts: ['[F][C;!$(C=O)]'],
            subgroups: [],
          },
          {
            name: 'Cl',
            smarts: ['[Cl][C;!$(C=O)]'],
            subgroups: [],
          },
          {
            name: 'Br',
            smarts: ['[Br][C;!$(C=O)]'],
            subgroups: [],
          },
          {
            name: 'I',
            smarts: ['[I][C;!$(C=O)]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Aromatic',
        smarts: [],
        subgroups: [
          {
            name: 'F',
            smarts: ['[F][c]'],
            subgroups: [],
          },
          {
            name: 'Cl',
            smarts: ['[Cl][c]'],
            subgroups: [],
          },
          {
            name: 'Br',
            smarts: ['[Br][c]'],
            subgroups: [],
          },
          {
            name: 'I',
            smarts: ['[I][c]'],
            subgroups: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Sulphur',
    smarts: [],
    subgroups: [
      {
        name: 'Thiol',
        smarts: [],
        subgroups: [
          {
            name: 'Aliphatic',
            displayName: 'Aliphatic thiol',
            smarts: ['[C;!$(C=O);!$(C=N)][SX2H1]'],
            subgroups: [],
          },
          {
            name: 'Aromatic',
            displayName: 'Aromatic thiol',
            smarts: ['[c;!$(C=O);!$(C=N)][SX2H1]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Disulphide',
        smarts: ['[S]-[S]'],
        subgroups: [],
      },
      {
        name: 'Thioether',
        smarts: ['[#6;!$(C=O)][S][#6;!$(C=O)]'],
        subgroups: [],
      },
      {
        name: 'Thioester',
        smarts: ['[CX3](=O)[SX2][#6]'],
        subgroups: [],
      },
      {
        name: 'Sulfoxide',
        smarts: ['[#6]S(=O)[#6]'],
        subgroups: [],
      },
      {
        name: 'Sulfone',
        smarts: ['[#6][SX3](=O)[#6]'],
        subgroups: [],
      },
      {
        name: 'Sulfamide',
        smarts: ['[#6][SX4](=O)(=O)[#6]'],
        subgroups: [],
      },
      {
        name: 'Sulfonic acid',
        smarts: ['[#6][SX4](=O)(=O)[OX2]'],
        subgroups: [],
      },
      {
        name: 'Sulfonic halide',
        smarts: ['[#6][SX4](=O)(=O)[F,Cl,Br]'],
        subgroups: [],
      },
      {
        name: 'Thiourea',
        smarts: ['[#6][NX3][CX3](=[SX1])[NX3]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Boron',
    smarts: [],
    subgroups: [
      {
        name: 'Boronic acid',
        smarts: ['B([OH1])[OH1]'],
        subgroups: [],
      },
      {
        name: 'Boronic ester',
        smarts: ['B(O[#6])O[#6]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Carbon',
    smarts: [],
    subgroups: [
      {
        name: 'Double bond',
        smarts: [],
        subgroups: [
          {
            name: 'Terminal',
            displayName: 'Terminal double bond',
            smarts: ['[CH2]=[C]'],
            subgroups: [],
          },
          {
            name: 'Non-terminal',
            displayName: 'Non-terminal double bond',
            smarts: ['[C;!H2]=[C;!H2]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Tripple bond',
        smarts: [],
        subgroups: [
          {
            name: 'Terminal',
            displayName: 'Terminal triple bond',
            smarts: ['[CH1]#[C]'],
            subgroups: [],
          },
          {
            name: 'Non-terminal',
            displayName: 'Non-terminal triple bond',
            smarts: ['[C;!H1]#[C;!H1]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Benzyl carbon',
        smarts: ['[c][C;H1,H2,H3]'],
        subgroups: [],
      },
      {
        name: 'Allylic carbon',
        smarts: ['[C]=[C]-[C;H1,H2,H3]'],
        subgroups: [],
      },
      {
        name: 'Alpha-beta unsaturated - EWG',
        smarts: ['[C]=[C]-[C$(C=O),C$(C#N),N$([N+](=O)[O-]),S$(S(=O)(=O))]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Protecting groups',
    smarts: [],
    subgroups: [
      {
        name: 'Amine',
        smarts: [],
        image: 'protecting-groups-amine',
        subgroups: [
          {
            name: 'NBoc',
            smarts: ['[NX3][CX3](=[OX1])[OX2][CX4]([CH3])([CH3])[CH3]'],
            subgroups: [],
          },
          {
            name: 'NCbz',
            smarts: ['[NX3][CX3](=[OX1])[OX2][CX4H2]c1ccccc1'],
            subgroups: [],
          },
          {
            name: 'NBn',
            smarts: ['[NX3][CX4]c1ccccc1'],
            subgroups: [],
          },
          {
            name: 'NTs',
            smarts: ['[NX3][SX4](=O)(=O)c1ccc([CH3])cc1'],
            subgroups: [],
          },
          {
            name: 'NTr',
            smarts: ['NC(c1ccccc1)(c2ccccc2)c3ccccc3'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Alcohol',
        smarts: [],
        image: 'protecting-groups-alcohol',
        subgroups: [
          {
            name: 'OTMS',
            smarts: ['[O][Si]([CH3])([CH3])[CH3]'],
            subgroups: [],
          },
          {
            name: 'OTBDMS',
            smarts: ['[O][Si]([CH3])([CH3])[C]([CH3])([CH3])[CH3]'],
            subgroups: [],
          },
          {
            name: 'OMOM',
            smarts: ['[O][CH2](O[CH3])'],
            subgroups: [],
          },
          {
            name: 'OTHP',
            smarts: ['[O][CH]1(O[CH2][CH2][CH2][CH2]1)'],
            subgroups: [],
          },
          {
            name: 'OBn',
            smarts: ['[O][CX4]c1ccccc1'],
            subgroups: [],
          },
          {
            name: 'Allyl ether',
            smarts: ['[O][CH2][CH]=[CH2]'],
            subgroups: [],
          },
          {
            name: 'Methyl (phenol)',
            smarts: ['c[O][CH3]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Carbonyl',
        smarts: [],
        subgroups: [
          {
            name: 'Acetal',
            smarts: ['[CX4$(C(O)(O)C);CX4([CH1](O)(O))]([OX2])[OX2]'],
            subgroups: [],
          },
          {
            name: 'Orthoester',
            smarts: ['[CX4]([OX2])([OX2])[OX2]'],
            subgroups: [],
          },
          {
            name: 'COOMe',
            smarts: ['[CX3](=[OX1])[OX2][CH3]'],
            subgroups: [],
          },
          {
            name: 'COOtBu',
            smarts: ['[CX3](=[OX1])[OX2][CH0]([CH3])([CH3])[CH3]'],
            subgroups: [],
          },
          {
            name: 'COOBn',
            smarts: ['[CX3](=[OX1])[OX2][CX4]c1ccccc1'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Silyl alkyne',
        smarts: ['C#C[Si]'],
        subgroups: [],
      },
    ],
  },
  {
    name: 'Misc',
    smarts: [],
    subgroups: [
      {
        name: 'Epoxide',
        smarts: ['[C+0]1-[C+0][O]1'],
        subgroups: [],
      },
      {
        name: 'Diazo',
        smarts: ['c[NX3]=[NX3]c'],
        subgroups: [],
      },
      {
        name: 'Isonitrile',
        smarts: ['[CX1-]#[NX2+]'],
        subgroups: [],
      },
      {
        name: 'Nitro',
        smarts: [],
        image: 'misc-nitro',
        subgroups: [
          {
            name: 'Aliphatic',
            smarts: ['[C][NX3;+](=[OX1])[OX1;-]'],
            subgroups: [],
          },
          {
            name: 'Aromatic',
            smarts: ['[c][NX3;+](=[OX1])[OX1;-]'],
            subgroups: [],
          },
        ],
      },
      {
        name: 'Cyanate',
        smarts: ['[O][C]#[N]'],
        subgroups: [],
      },
      {
        name: 'Isocyanate',
        smarts: ['[#6]N=C=O'],
        subgroups: [],
      },
      {
        name: 'Azide',
        smarts: ['N=[N+]=[N-]'],
        subgroups: [],
      },
      {
        name: 'Hydrazine',
        smarts: ['[#6][NX3H1][NX3H1]'],
        subgroups: [],
      },
    ],
  },
];

function propagateSmarts(groups: Group[]): Group[] {
  return groups.map(group => {
    const subgroups = propagateSmarts(group.subgroups);
    return {
      ...group,
      subgroups,
      smarts: [...group.smarts, ...subgroups.flatMap(g => g.smarts)],
    };
  });
}

function getSmartsString(smarts: string[]) {
  return sortBy(smarts).join(' ');
}

function mapGroupsBySmarts(groups: Group[]): Record<string, Group> {
  return groups.reduce((acc, group) => {
    const smartsStr = getSmartsString(group.smarts);
    const base = { ...acc, [smartsStr]: group };

    if (group.subgroups.length > 0) {
      return { ...base, ...mapGroupsBySmarts(group.subgroups) };
    }

    return base;
  }, {} as Record<string, Group>);
}

export const smartsRichFunctionalGroups = propagateSmarts(functionalGroups);

export const functionalGroupsBySmarts = mapGroupsBySmarts(smartsRichFunctionalGroups);
